import { Component, Input, OnInit } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { AdminServiceService } from '../../service/admin-service.service';
import { UiService } from '../../service/ui.service';
import { CreateCurrencyComponent } from '../create-currency/create-currency.component';

@Component({
  selector: 'app-exchange',
  templateUrl: './exchange.component.html',
  styleUrls: ['./exchange.component.scss'],
})
export class ExchangeComponent implements OnInit {
  @Input() title: string;

  currencies:any[] = []

  constructor(
    private adminService: AdminServiceService,
    private uiService: UiService
  ) { }

  ngOnInit() {
    this.adminService.getCurrencies().subscribe((res:any) => {
      this.currencies = res.data;
    })
  }
  
  async create(props = null){
    const { data, role } = await this.uiService.createModal(CreateCurrencyComponent, { onEditCurrency: props });    
    if(data){
      if(role === 'create'){
        this.adminService.storeCurrencies(data).subscribe((res:any) => {
          this.currencies.push(res.data)
        })
      }else if(role === 'edit'){
        this.adminService.updateCurrencies({...data, id: props.id}).subscribe((res:any) => {
          this.currencies = this.currencies.filter(currencie => currencie.id !== props.id);
          this.currencies.unshift(res.data);
        })
      }
    }
  }

  async deleteCurrency(currencie?){
    const resModal = await this.uiService.presentAlert('Elminar moneda', `¿Deseas eliminar ${currencie.name}?.`);
    console.log(resModal);
    
    if(resModal){
      this.adminService.deleteCurrencies(currencie).subscribe(res => {
        this.currencies = this.currencies.filter(item => item.id !== currencie.id);
      })
    }
  }
}
